// @flow

import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import EnterPromoCode from './EnterPromoCode';
import { InvoiceStorage } from '../helpers';
import { Order } from '../Common';
import { appendHoneyGuide } from '../../../lib/utils';
import { Stripe, WhitePanel, Prices, Page, Loading } from '../../../components';
import { useSelector } from '../../../redux/reduxDB';
import { getCartData } from '../../../redux/cart';
import { trackCartPaymentSuccess, trackHGCreditUsage} from '../../../redux/actions/analyticsEventActions';

const title = appendHoneyGuide('Cart Payment');

function CartPayment(props: RouteComponentProps) {
  const [invoice, orderIds] = useSelector(getCartData);
  const [promocodeResponse, setPromocodeResponse] = React.useState(null);
  const handlePromocodeResponse = res => {
    const { trackHGCreditUsage } = props;
    setPromocodeResponse(res);
    trackHGCreditUsage();
  };

  if (!invoice || !orderIds) return <Loading />;

  let { currency, rate, discount, amount, id, status } = invoice;
  const isPending = status.toLowerCase() === 'pending';


  if (promocodeResponse) { 
    const { promocodeAmount, purchaseAmount, totalAmount } = promocodeResponse;

    rate = purchaseAmount;
    discount = promocodeAmount; 
    amount = totalAmount; 
  }

  const trackPaymentSuccess = () => {
    const { trackCartPaymentSuccess } = props;
    try {
      trackCartPaymentSuccess(amount);
    } catch (error) {
      console.log('Failed To track payment Success!',error);
    }
  };

  return (
    <Page title={title}>
      <Container>
        <Row>
          {isPending && (
            <React.Fragment>
              <Stripe
                invoiceId={id}
                promocode={promocodeResponse && promocodeResponse.promocode}
                onSuccess={() => {
                  trackPaymentSuccess();
                  InvoiceStorage.remove();
                  
                  // refreshing the page to reload the invoice data.
                  window.location = `${props.location.pathname}/${id}/payment-success`;
                }}
              />
            </React.Fragment>
          )}
          <Col lg="6" className="trek-summary">
            <WhitePanel>
              <h2>Cart Summary</h2>
              {orderIds.map(orderId => (
                <Order orderId={orderId} key={orderId} />
              ))}
                <Prices
                  discount={discount}
                  basePrice={rate}
                  grandTotal={amount}
                  currency={currency}
              />
              <EnterPromoCode
                invoiceId={id}
                onSuccess={handlePromocodeResponse}
                onDelete={() => setPromocodeResponse(null)}
                isPromocodeApplied={promocodeResponse && promocodeResponse}
                enterHoneyguideCreditButtonId="cart-enter-HG-credit-btn"
                applyHoneyguideCreditButtonId="cart-apply-hg-credit-btn"
              />
            </WhitePanel>
          </Col>
        </Row>
      </Container>
    </Page>
  );
}

const ConnectedCartPayment = connect(
  null,
  { trackCartPaymentSuccess, trackHGCreditUsage }
)(CartPayment);

export default withRouter(ConnectedCartPayment);



// WEBPACK FOOTER //
// ./src/screens/Cart/Payment/CartPayment.js